export const ITEM_REWARD_LIST_REQUEST = "ITEM_REWARD_REQUEST";
export const ITEM_REWARD_LIST_SUCCESS = "ITEM_REWARD_REQUEST_SUCCESS";
export const ITEM_REWARD_CREATE_REQUEST = "ITEM_REWARD_CREATE_REQUEST";
export const ITEM_REWARD_DELETE_REQUEST = "ITEM_REWARD_DELETE_REQUEST";
export const ITEM_REWARD_ARCHIVE_REQUEST = "ITEM_REWARD_ARCHIVE_REQUEST";
export const ITEM_REWARD_UNARCHIVE_REQUEST = "ITEM_REWARD_UNARCHIVE_REQUEST";
export const ITEM_REWARD_CREATE_FORM_NAME = "createItemReward";
export const READ_ITEM_REWARD = 276000;
export const CREATE_ITEM_REWARD = 276001;
export const UPDATE_ITEM_REWARD = 276002;
export const ARCHIVE_ITEM_REWARD = 276004;
export const UNARCHIVE_ITEM_REWARD = 276005;
export const ITEM_REWARD_STATUS_ARCHIVED = 0;
export const ITEM_REWARD_STATUS_ACTIVE = 1;
export const ITEM_REWARD_SUBMIT_RULES = {
  itemId: {
    required: true
  },
  points: {
    required: true
  }
};